<template lang="pug">
.project-file-category-list-popup(v-if="isOpened")
  BasePopup(@close="close(false)")
    ProjectFileCategoryList(:items="items" :selected="selected" :filesCount="filesCount" @select="$emit('select', $event)" vertical)
    .btns
      Btn(grey @click="close(false)") Отмена
      Btn(green @click="close(true)") Загрузить
</template>

<script>

import BasePopup from '@/components/BasePopup.vue';
import ProjectFileCategoryList from '@/components/ProjectFileCategoryList.vue';

export default {
  name: 'ProjectFileCategoryListPopup',
  components: { BasePopup, ProjectFileCategoryList },
  props: {
    items: Array,
    selected: Object,
    filesCount: Object,
  },
  data() {
    return {
      isOpened: false,
    };
  },
  controller: null,
  methods: {
    open() {
      this.isOpened = true;

      return new Promise((resolve, reject) => {
        this.$options.controller = { resolve, reject };
      });
    },
    close(res) {
      this.isOpened = false;
      this.$options.controller.resolve(res);
    },
  },
};
</script>

<style lang="scss" scoped>
  .project-file-category-list-popup {
    .btns {
      display: flex;
      gap: 20px;
      justify-content: flex-end;
    }

    @media (max-width: 450px) {
      .btns {
        flex-direction: column;
        align-items: stretch;
      }
    }
  }
</style>
